/*
 *
 * ShopSelector
 *
 * @version 1.0.0
 * @author Marco Alessandroni
 * @since 16-Apr-2025
*/

import { connect } from 'react-redux'
import ShopSelector from './ShopSelector'
import { doGetShopList, doSetShopSearchTerm, doSetShopLocalSelection } from 'Store/actions/shopPicker'
import { doShowToast } from 'Store/actions/toast'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  doGetShopList: (type) => dispatch(doGetShopList(type)),
  doSetShopSearchTerm: (payload) => dispatch(doSetShopSearchTerm(payload)),
  doSetShopLocalSelection: (payload) => dispatch(doSetShopLocalSelection(payload)),
  doShowToast: (key, moreInfo) => dispatch(doShowToast(key, moreInfo))
})

const mapStateToProps = (state) => ({
  shopSaved: nullSafe(() => state.shopPicker, []),
  shopLocalSelection: nullSafe(() => state.shopPicker.shopLocalSelection, {}),
  shopListLoading: nullSafe(() => state.userProfiling.shopListLoading, false),
  shopSearchTerm: nullSafe(() => state.shopPicker.searchTerm, ''),
  shopSelectionMode: nullSafe(() => state.shopPicker.shopSelectionMode, 'checkbox')
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(ShopSelector)
